import { PostalAddressInterface } from '@sport-activities/sdk';
import { alpha3ToAlpha2 } from 'i18n-iso-countries';

export class PostalAddress implements PostalAddressInterface {
  public addressCountry: string;
  public addressLocality: string;
  public addressRegion?: string;
  public identifier?: string;
  public postalCode: string;
  public streetAddress: string;

  constructor(init?: Partial<PostalAddress>) {
    Object.assign(this, init);
  }

  public get addressCountryCode(): string {
    return alpha3ToAlpha2(this.addressCountry.slice(-3));
  }
}
